import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledItem = styled.li`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
`;

const CustomMenuItem = ({ children }) => {
  return <StyledItem>{children}</StyledItem>;
};

CustomMenuItem.propTypes = {
  children: PropTypes.node.isRequired
};

export default CustomMenuItem;
